import { combineReducers } from "redux";
import epledgeHoldingReducer from "./EpledgeHolding";
import epledgeRequestDetailsReducer from "./EpledgeRequestDetails";
import epledgeRequestBookReducer from "./EpledgeRequestBook";
import epledgeUnpledgeReducer from "./EpledgeUnpledge";
import epledgePledgeReducer from "./EpledgePledge";
export default combineReducers({
    epledgeHoldingReducer: epledgeHoldingReducer,
    epledgeRequestDetailsReducer: epledgeRequestDetailsReducer,
    epledgeRequestBookReducer: epledgeRequestBookReducer,
    epledgeUnpledgeReducer: epledgeUnpledgeReducer,
    epledgePledgeReducer: epledgePledgeReducer,
});
